import { useState, useEffect } from 'react';
// @mui
import { styled } from '@mui/material/styles';
import {
  SetDetailPositionForm,
  SetContextForm,
  SetTaskForm,
  ReviewRequestForm,
  DirectJobPostHeader,
  SetMonthlyBudgetForm,
} from './';
import {
  JobPostHelpDialog,
} from '../';
import {
  CrewRejectHistoryDialog,
} from '../../';

// --------------------------------------------------

const JobPostFormStyle = styled('div')(({ theme }) => ({
  maxWidth: 760,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  padding: theme.spacing(3, 0),
}));

// --------------------------------------------------

export default function DirectJobPosting({ prevForm, jobPost, reload, isEdit, close, toggleDialog }) {
  // 작성 & 수정
  const [renderMethod, setRenderMethod] = useState('status');
  const [step, setStep] = useState(null);
  // dialog
  const [isOpenMeetingDialog, setIsOpenMeetingDialog] = useState(false);
  const [crewRejectHistoryOpen, setCrewRejectHistoryOpen] = useState(false);
  const techLeadSelected = jobPost?.detail_role?.role === "Tech Lead";
  const aiPositionSelected = jobPost?.select_ai_position;

  const openMeetingDialog = () => {
    setIsOpenMeetingDialog(true);
  }

  const closeMeetingDialog = () => {
    setIsOpenMeetingDialog(false);
  }

  const openCrewRejectHistoryDialog = () => {
    setCrewRejectHistoryOpen(true);
  }

  const resetModeAndReload = async (jobPostId) => {
    setRenderMethod('status');
    reload(jobPostId);
  };

  const nextStep = (jobPostId) => {
    const nextStep = step + 1;
    if (jobPost?.position === 'developer' && techLeadSelected && nextStep === 4) {
      setStep(5);
    } else {
      setStep(nextStep);
    }
    reload(jobPostId);
  };

  const DEV_STATUS_COMPONENT = {
    'method-direct': <SetDetailPositionForm jobPost={jobPost} isEdit={isEdit} next={resetModeAndReload} close={close} />,
    'detail-position-set': <SetContextForm jobPost={jobPost} isEdit={isEdit} next={resetModeAndReload} close={close} />,
    'context-set': <SetMonthlyBudgetForm jobPost={jobPost} isEdit={isEdit} next={resetModeAndReload} close={close} />,
    'monthly-budget-set': <SetTaskForm jobPost={jobPost} isEdit={isEdit} next={resetModeAndReload} toggleDialog={toggleDialog} />,
    'task-set': <ReviewRequestForm jobPost={jobPost} toggleDialog={toggleDialog} />,
  };

  const DEV_STEP_COMPONENT = {
    1: <SetDetailPositionForm jobPost={jobPost} isEdit={isEdit} next={nextStep} close={close} />,
    2: <SetContextForm jobPost={jobPost} isEdit={isEdit} next={nextStep} close={close} />,
    3: <SetMonthlyBudgetForm jobPost={jobPost} isEdit={isEdit} next={nextStep} close={close} />,
    4: <SetTaskForm jobPost={jobPost} isEdit={isEdit} next={nextStep} toggleDialog={toggleDialog} />,
    5: <ReviewRequestForm jobPost={jobPost} toggleDialog={toggleDialog} />,
  };

  const DEV_EDIT_STEP_COMPONENT = {
    1: <SetDetailPositionForm jobPost={jobPost} isEdit={isEdit} next={nextStep} close={close} />,
    2: <SetContextForm jobPost={jobPost} isEdit={isEdit} next={nextStep} close={close} />,
    3: <SetMonthlyBudgetForm jobPost={jobPost} isEdit={isEdit} next={nextStep} close={close} />,
    4: <SetTaskForm jobPost={jobPost} isEdit={isEdit} next={nextStep} toggleDialog={toggleDialog} />,
  };

  // other position
  const NODEV_STATUS_COMPONENT = {
    'method-direct': <SetDetailPositionForm jobPost={jobPost} isEdit={isEdit} next={resetModeAndReload} close={close} />,
    'detail-position-set': <SetMonthlyBudgetForm jobPost={jobPost} isEdit={isEdit} next={resetModeAndReload} close={close} />,
    'monthly-budget-set': <SetTaskForm jobPost={jobPost} isEdit={isEdit} next={resetModeAndReload} toggleDialog={toggleDialog} />,
    'task-set': <ReviewRequestForm jobPost={jobPost} toggleDialog={toggleDialog} />,
  };

  const NODEV_STEP_COMPONENT = {
    1: <SetDetailPositionForm jobPost={jobPost} isEdit={isEdit} next={nextStep} close={close} />,
    2: <SetMonthlyBudgetForm jobPost={jobPost} isEdit={isEdit} next={nextStep} close={close} />,
    3: <SetTaskForm jobPost={jobPost} isEdit={isEdit} next={nextStep} toggleDialog={toggleDialog} />,
    4: <ReviewRequestForm jobPost={jobPost} toggleDialog={toggleDialog} />,
  };

  const NODEV_EDIT_STEP_COMPONENT = {
    1: <SetDetailPositionForm jobPost={jobPost} isEdit={isEdit} next={nextStep} close={close} />,
    2: <SetMonthlyBudgetForm jobPost={jobPost} isEdit={isEdit} next={nextStep} close={close} />,
    3: <SetTaskForm jobPost={jobPost} isEdit={isEdit} next={nextStep} toggleDialog={toggleDialog} />,
  };

  const STATUS_COMPONENT = jobPost?.position === 'developer' ? DEV_STATUS_COMPONENT : NODEV_STATUS_COMPONENT;
  const STEP_COMPONENT = jobPost?.position === 'developer' ? DEV_STEP_COMPONENT : NODEV_STEP_COMPONENT;
  const EDIT_STEP_COMPONENT = jobPost?.position === 'developer' ? DEV_EDIT_STEP_COMPONENT : NODEV_EDIT_STEP_COMPONENT;

  const noDetailPosition = ['product-manager', 'operator', 'finance'];

  const goStep = (goto) => {
    if (isEdit) return ;
    if (noDetailPosition.includes(jobPost?.position) && goto === 1) prevForm();
    if (step === 1 && goto === 0) {
      prevForm();
    } else if (jobPost?.position === 'developer' && techLeadSelected && goto === 4) {
      setRenderMethod('step');
      setStep(3);
    } else if (aiPositionSelected && goto === 2) {
      prevForm();
    } else {
      setRenderMethod('step');
      setStep(goto);
    }
  };

  useEffect(() => {
    if (isEdit) {
      setRenderMethod('edit');
      if (aiPositionSelected) {
        setStep(3);
      } else if (noDetailPosition.includes(jobPost?.position)) {
        setStep(2);
      } else {
        setStep(1);
      }
    }
  }, [isEdit])

  useEffect(() => {
    if (isEdit) {
      setRenderMethod('edit');
    } else if (renderMethod === 'status') {
      switch (jobPost?.status) {
        case 'method-direct':
          setStep(1);
          break;
        case 'detail-position-set':
          setStep(2);
          break;
        case 'context-set':
          setStep(2);
          break;
        case 'monthly-budget-set':
          setStep(3);
          break;
        case 'task-set':
          setStep(4);
          break;
        default:
          setStep(null);
          break;
      };
    } else if (renderMethod === 'step') {
      setStep(step);
    }
  }, [renderMethod, jobPost]);

  return (
    <JobPostFormStyle>
      <DirectJobPostHeader
        jobPost={jobPost}
        step={step}
        isEdit={isEdit}
        close={close}
        goStep={goStep}
        openMeetingDialog={openMeetingDialog}
        openRejectHistoryDialog={openCrewRejectHistoryDialog}
      />
      {renderMethod === 'status' && (
        STATUS_COMPONENT[jobPost?.status]
      )}
      {renderMethod === 'step' && (
        STEP_COMPONENT[step]
      )}
      {renderMethod === 'edit' && (
        EDIT_STEP_COMPONENT[step]
      )}
      <JobPostHelpDialog
        jobPostId={jobPost?.id}
        open={isOpenMeetingDialog}
        closeDialog={closeMeetingDialog}
      />

      <CrewRejectHistoryDialog
        isOpen={crewRejectHistoryOpen}
        closeDialog={() => setCrewRejectHistoryOpen(false)}
        history={jobPost?.candidate_set}
        editJobPost={null}
      />
    </JobPostFormStyle>
  )
}
